export default __webpack_public_path__ + "static/char-46-anr-00d0a52227caa46cc305d48fefc1bf02.webp";